import { render, staticRenderFns } from "./ReportMobile.vue?vue&type=template&id=3600aef5"
import script from "./ReportMobile.vue?vue&type=script&lang=js"
export * from "./ReportMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports